import { getDefaultLatitude, getDefaultLongitude } from '../../../../../utils';

const defaultConfig = {
    form: {
        name: {
            name: 'name',
            Component: 'FormInput',
            props: {
                variant: 'outlined',
                label: 'Name',
                required: true,
            },
            widths: { sm: 12 },
        },
        address: {
            name: 'address',
            Component: 'FormInput',
            props: {
                label: 'Address',
                variant: 'outlined',
            },
        },
        geofence: {
            name: 'geofence',
            Component: 'Geofence',
            props: {
                label: 'Geofence',
                maxFences: 1,
                center: { lat: getDefaultLatitude(), lng: getDefaultLongitude() },
                siteType: 'washFacility',
                addressField: 'address',
                shouldRefetchOnEdit: false,
            },
        },
    },
    form_layout: [
        {
            Component: 'Section',
            fields: ['name', 'address', 'geofence'],
        },
    ],
    validation: {
        type: 'object',
        properties: {
            name: {
                type: 'string',
                required: true,
            },
        },
    },
    validation_config: {
        errMessages: {
            name: {
                required: 'Name is required',
            },
        },
    },
};

export default defaultConfig;
